import { Transform } from '@kurtosys/ksys-app-template/dist/query/transform';
import { IExecutionOptions } from '@kurtosys/ksys-app-template/dist/models/query';
import { ITransformOptions } from '@kurtosys/ksys-app-template/dist/models/query/transforms';
import { TranslationStore } from '../../stores';

export function transformValue(
    value: string,
    transforms: Array<ITransformOptions>,
    translationStore: TranslationStore,
    executionOptions: IExecutionOptions
) {
    let rawValue = value;
    for (const transformConfig of transforms) {
        const transform = new Transform(
            transformConfig,
            translationStore.translationHelper
        );
        rawValue = transform.execute(rawValue, null, executionOptions);
    }
    return rawValue;
}



// WEBPACK FOOTER //
// ./src/utils/transform/transform.ts